import searchElementMap from "../components/components/search/lazy-index.js";
if (typeof window !== "undefined") {
  const discover = async (root) => {
    const rootTagName = root instanceof Element ? root.tagName.toLowerCase() : "";
    const rootIsAtomicElement = rootTagName?.startsWith("atomic-");
    const tags = [...root.querySelectorAll(":not(:defined)")].map((el) => el.tagName.toLowerCase()).filter((tag) => tag.startsWith("atomic-"));
    if (rootIsAtomicElement && !customElements.get(rootTagName)) {
      tags.push(rootTagName);
    }
    if (rootIsAtomicElement) {
      const childTemplates = root.querySelectorAll("template");
      for (const template of childTemplates) {
        discover(template.content);
        observer.observe(template.content, { subtree: true, childList: true });
      }
      if ("shadowRoot" in root && root.shadowRoot) {
        discover(root.shadowRoot);
        observer.observe(root.shadowRoot, { subtree: true, childList: true });
      }
    }
    const tagsToRegister = [...new Set(tags)];
    await Promise.allSettled(
      tagsToRegister.map((tagName) => register(tagName))
    );
    customElements.upgrade(root);
  };
  const register = (tagName) => {
    if (customElements.get(tagName)) {
      return Promise.resolve();
    }
    return searchElementMap[tagName]?.();
  };
  const observer = new MutationObserver((mutations) => {
    for (const { addedNodes } of mutations) {
      for (const node of addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          discover(node);
        }
      }
    }
  });
  discover(document.body);
  observer.observe(document.documentElement, { subtree: true, childList: true });
}
